import { ArrayHelpers, DatesHelpers } from "@core/helpers";
import { ICandidate, CandidateSelectedModel, CandidateModel, CandidateCanceledModel } from "@core/models/extra";
import { QualificationModel } from "@core/models/common/qualification.model";
import { RecruitmentAEModel } from "./recruitment-ae.model";
import { IRecruitment, IRecruitmentAE } from "./recruitment.interface";
import { ShiftModel } from "./shift.model";

export class RecruitmentBookingExpressAdapter {
  constructor(recruitment = {}) {
    this[IRecruitment.temporaryJob] = recruitment[IRecruitment.temporaryJob];
    this[IRecruitment.candidates] = recruitment[IRecruitment.candidates];

    const shifts = this.getShifts();
    const selectedCandidates = this.extractSelectedCandidates({ shifts });
    const canceledCandidates = this.extractCanceledCandidates({ shifts });

    const startingDateTime = this.getStartingDateTime({ shifts });
    const startDate = DatesHelpers.getDateMomentIfExist(this.getJob()[IRecruitmentAE.startDate]);
    const endDate = DatesHelpers.getDateMomentIfExist(this.getJob()[IRecruitmentAE.endDate]);

    return new RecruitmentAEModel({
      ...recruitment,
      [IRecruitment.selectedCandidates]: selectedCandidates,
      [IRecruitment.currentCandidates]: this.getAllCandidates(),
      [IRecruitment.canceledCandidates]: canceledCandidates,
      [IRecruitment.qualificationLabel]: this.getQualification().getLabel(),
      [IRecruitment.precisions]: this.getJob()[IRecruitmentAE.precisions],
      // RecruitmentAE specifics
      [IRecruitmentAE.canBeCanceled]: this.getJob()[IRecruitmentAE.canBeCanceled],
      [IRecruitmentAE.isFilled]: this.getJob()[IRecruitmentAE.isFilled],
      [IRecruitmentAE.missionEnded]: this.getJob()[IRecruitmentAE.missionEnded],
      [IRecruitmentAE.missionStarted]: this.getJob()[IRecruitmentAE.missionStarted],
      [IRecruitmentAE.nbExtraRequired]: this.getJob()[IRecruitmentAE.nbExtraRequired],
      [IRecruitmentAE.nbExtrasBooked]: this.getJob()[IRecruitmentAE.nbExtrasBooked],
      [IRecruitmentAE.startDate]: startDate,
      [IRecruitmentAE.startingDateTime]: startingDateTime,
      [IRecruitmentAE.endDate]: endDate,
    });
  }

  getJob() {
    return this[IRecruitment.temporaryJob] || {};
  }

  getShifts() {
    return ArrayHelpers.ensureArray(this.getJob()[IRecruitmentAE.shifts]).map((shift) => new ShiftModel(shift));
  }

  getStartingDateTime({ shifts }) {
    const firstShift = shifts[0];
    if (firstShift) {
      return DatesHelpers.getDateMomentIfExist(firstShift.getStartingDateTime());
    }
    return undefined;
  }

  getQualification() {
    return new QualificationModel(this.getJob()[IRecruitmentAE.qualification]);
  }

  getAllCandidates() {
    return ArrayHelpers.ensureArray(this[IRecruitment.candidates]).map((candidate) => new CandidateModel(candidate));
  }

  extractSelectedCandidates({ shifts }) {
    const selectedCandidates = [];
    shifts.forEach((shift) => {
      if (shift.hasExtraBooked() && !shift.isCanceledByExtra()) {
        selectedCandidates.push(shift.getExtraBooked());
      }
    });

    return this.ensureCandidateUnicity(selectedCandidates).map((candidate) => new CandidateSelectedModel(candidate));
  }

  extractCanceledCandidates({ shifts }) {
    const canceledCandidates = [];
    shifts.forEach((shift) => {
      if (shift.hasExtraBooked() && shift.isCanceledByExtra()) {
        canceledCandidates.push(shift.getExtraBooked());
      }
    });

    return this.ensureCandidateUnicity(canceledCandidates).map((candidate) => new CandidateCanceledModel(candidate));
  }

  ensureCandidateUnicity(candidates) {
    return ArrayHelpers.deduplicateByProperty(candidates, [ICandidate.id]);
  }
}
